const definition: any = {
    localhost: ['subscription'],
    /*Przemek DEV*/ '46zuzCdjUgklxOVLvpi0AV': ['subscription'],
    /*Dominik DEV*/ '6FBEtRieXqnD2PNnnIowJ6': ['subscription'],
};

export const getUserFeatureFlags = (userId: string) => {
    return definition[userId] || [];
};
